import * as d3 from "d3";

import {
  OverlapCard,
  SurveyButtonCard,
  TableCard,
  TreeCard,
} from "./PatientViews";

import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import OverlapTreeLinkToggle from "./OverlapTreeLinkToggle";
import PatientInfoCard from "./PatientInfoCard";
import React from "react";
import Row from "react-bootstrap/Row";

class Dashboard extends React.Component {
  render() {
    return (
      <Container fluid>
        <PatientInfoCard micro_id={this.props.micro_id} />
        <div className="overlap-tree-link-wrapper">
          <Row style={{ paddingLeft: "10.45px", paddingRight: "10.45px", paddingTop: "15px", paddingBottom: "10.45px" }}>
            <Col md={8}>
              <Row>
                <OverlapCard micro_id={this.props.micro_id} surveyMode={4} />
              </Row>
            </Col>
            <Col md={4}>
              <Row>
                <TreeCard micro_id={this.props.micro_id} />
              </Row>
            </Col>
          </Row>
          <div className="overlap-tree-link-button-wrapper">
            <OverlapTreeLinkToggle />
          </div>
        </div>
        <SurveyButtonCard />
      </Container>
    );
  }
}

class TableAndOverlapAndTreeDashboard extends React.Component {
  render() {
    return (
      <Container fluid>
        <PatientInfoCard micro_id={this.props.micro_id} />
        <div className="overlap-tree-link-wrapper">
          <Row style={{ paddingLeft: "10.45px", paddingRight: "10.45px", paddingTop: "15px", paddingBottom: "10.45px" }}>
            <Col md={8}>
              <Row>
                <OverlapCard micro_id={this.props.micro_id} />
              </Row>
            </Col>
            <Col md={4}>
              <Row>
                <TreeCard micro_id={this.props.micro_id} />
              </Row>
            </Col>
          </Row>
          <div className="overlap-tree-link-button-wrapper">
            <OverlapTreeLinkToggle />
          </div>
        </div>
        <SurveyButtonCard />
      </Container>
    );
  }
}

class TableAndOverlapDashboard extends React.Component {
  render() {
    return (
      <Container fluid>
        <PatientInfoCard micro_id={this.props.micro_id} />
        <Row style={{ paddingLeft: "10.45px", paddingRight: "10.45px", paddingTop: "15px", paddingBottom: "10.45px" }}>
          <Col md={12} >
            <Row>
              <OverlapCard micro_id={this.props.micro_id} />
            </Row>
          </Col>
        </Row>
        <SurveyButtonCard />
      </Container>
    );
  }
}

class TableOnlyDashboard extends React.Component {
  render() {
    return (
      <Container fluid>
        <PatientInfoCard micro_id={this.props.micro_id} />
        <Row style={{ paddingLeft: "10.45px", paddingRight: "10.45px", paddingTop: "15px", paddingBottom: "10.45px" }}>
          <Col md={12} >
            <Row>
              <TableCard micro_id={this.props.micro_id} />
            </Row>
          </Col>
        </Row>
        <SurveyButtonCard />
      </Container>
    );
  }
}

export {
  Dashboard,
  TableOnlyDashboard,
  TableAndOverlapDashboard,
  TableAndOverlapAndTreeDashboard,
};
